import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import CartaPorteUbicacionForm from './CartaPorteUbicacionForm';
import CartaPorteUbicacionesList from './CartaPorteUbicacionesList';
import CartaPorteUbicacionesCalculator from '../../../support/cartaporte/CartaPorteUbicacionesCalculator';

class CartaPorteUbicacionesManager extends Component {
  state = {};

  handleOnAdd = (data) => {
    const { Ubicaciones = {} } = this.props.data;
    const { Ubicacion = [] } = Ubicaciones;

    const newData = Ubicacion.concat([
      {
        id: Uuid.v4(),
        ...data,
      },
    ]);

    this.handleOnListChange(newData);
  };

  handleOnAddFile = (data) => {
    const { Ubicaciones = {} } = this.props.data;
    const { Ubicacion = [] } = Ubicaciones;

    let newData = _.map(data, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    newData = Ubicacion.concat(newData);

    this.handleOnListChange(newData);
  };

  handleOnListChange = (data) => {
    const totalizer = CartaPorteUbicacionesCalculator.make(data).get();
    const event = { isValid: true, name: 'ubicaciones' };

    const newData = {
      ...this.props.data,
      TotalDistRec: totalizer.TotalDistRec,
      Ubicaciones: {
        Ubicacion: data,
      },
    };

    this.props.onChange(newData, event);
  };

  handleOnEdit = (item) => {
    this.setState(
      {
        data: { ...item },
      },
      () => {
        this.setState({
          data: undefined,
        });
      }
    );
  };

  handleOnDelete = () => {
    const event = { isValid: false, name: 'ubicaciones' };

    this.props.onChange(
      {
        ...this.props.data,
        Ubicaciones: {
          Ubicacion: [],
        },
      },
      event
    );
  };

  render() {
    const { data } = this.state;
    const { Ubicaciones = {} } = this.props.data;
    const { Ubicacion = [] } = Ubicaciones;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Ubicaciones</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <CartaPorteUbicacionForm
              data={ data }
              onAdd={ this.handleOnAdd }
              onAddFile={ this.handleOnAddFile }
            />
          </div>

          <div className="pt-2">
            <CartaPorteUbicacionesList
              data={ Ubicacion }
              onEdit={ this.handleOnEdit }
              onChange={ this.handleOnListChange }
            />
          </div>

          <Row>
            <Col>
              <Button
                variant="danger"
                disabled={ Ubicacion.length === 0 }
                onClick={ this.handleOnDelete }
              >
                Eliminar ubicaciones
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default CartaPorteUbicacionesManager;
